import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'black-account-card',
  standalone: false,

  templateUrl: './account-card.component.html',
  styleUrl: './account-card.component.css',
})
export class AccountCardComponent {
  @Input()
  provider = 'zoom';

  @Input()
  status: 'Active' | 'Inactive' = 'Active';

  @Input()
  accountUserId = '';

  @Input()
  accountUsername = '';

  @Input()
  isDefault = false;

  @Output()
  unlinkAccountEvent: EventEmitter<{ provider: string; userId: string }> =
    new EventEmitter();

  unlinkAccount() {
    this.unlinkAccountEvent.emit({
      provider: this.provider,
      userId: this.accountUserId,
    });
  }
}
